var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 19.1715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Camera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.1369,
    width: 4.0036,
    height: 0.9954
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4941,7.6292c.5518,0,.9955-.4436.9955-.9956s-.4436-.9954-.9955-.9954-.9955.4436-.9955.9954.4437.9956.9955.9956Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7457,3.1278L15.5059.1304h-7.2714l-2.0018,2.9974H0v11.4915c0,2.4887,2.0127,4.5012,4.5014,4.5012h14.9973c2.4887,0,4.5013-2.0125,4.5013-4.5012V3.1278h-6.2543ZM23.0045,14.63h-.0108c0,1.937-1.569,3.4951-3.495,3.4951H4.5014c-1.9369,0-3.495-1.5689-3.495-3.4951V4.1341h5.7673l2.0018-2.9972h6.2326l2.2399,2.9972h5.7565v10.4959h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12,6.1555c-2.7609,0-4.9991,2.2381-4.9991,4.999s2.2381,4.9994,4.9991,4.9994,4.9991-2.2381,4.9991-4.9994-2.2381-4.999-4.9991-4.999ZM11.9946,15.1473c-2.2111,0-4.0036-1.7925-4.0036-4.0033s1.7925-4.0037,4.0036-4.0037,4.0036,1.7925,4.0036,4.0037-1.7925,4.0033-4.0036,4.0033Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.85feb3efc390f46ce4b46a4d9c58f1f5.svg";
export { ForwardRef as ReactComponent };